meedy.factory('meedy.passwordService', ['$q', '$translate', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, $translate, baseService, objectHelper, config) {

        function PasswordService() {

            this.changePassword = function (oldPassword, newPassword) {
                return baseService.put(config.API_URL + '/passwords', {'oldPassword' : oldPassword, 'newPassword' : newPassword}).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

        }

        return new PasswordService();
    }
]);
